import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "w-full h-full relative flex items-center justify-center" };
const _hoisted_2 = ["for"];
const _hoisted_3 = ["id", "name", "accept", "disabled"];
const _hoisted_4 = {
    key: 1,
    class: "italic mt-2 text text-gray-700"
};
const _hoisted_5 = {
    key: 2,
    class: "italic text text-gray-700"
};
const _hoisted_6 = {
    key: 3,
    class: "italic text text-red-700"
};
const _hoisted_7 = { class: "w-full p-4 flex justify-between" };
const _hoisted_8 = { class: "flex" };
const _hoisted_9 = { class: "ml-4 self-center" };
const _hoisted_10 = {
    key: 0,
    class: "flex"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
    key: 1,
    class: "flex items-center"
};
const _hoisted_14 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CloudUploadIcon = _resolveComponent("CloudUploadIcon");
    const _component_DocumentTextIcon = _resolveComponent("DocumentTextIcon");
    const _component_DownloadIcon = _resolveComponent("DownloadIcon");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("div", null, [
        (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["relative border-dashed border-2 h-32 rounded col-span-6 w-full cursor-pointer ease-out duration-200", {
                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disabled,
                        'border-green-400': _ctx.dropzoneActive,
                    }]),
                onClick: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.handleClickFileUpload && _ctx.handleClickFileUpload(...args))),
                onDrop: _cache[2] || (_cache[2] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.handleFileDrop && _ctx.handleFileDrop(...args)), ["prevent"])),
                onDragover: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.dropzoneActive = true), ["prevent"])),
                onDragenter: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.dropzoneActive = true), ["prevent"])),
                onDragleave: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.dropzoneActive = false), ["prevent"])),
                onMouseover: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.dropzoneActive = true), ["prevent"])),
                onMouseenter: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.dropzoneActive = true), ["prevent"])),
                onMouseleave: _cache[8] || (_cache[8] = _withModifiers(($event) => (_ctx.dropzoneActive = false), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_CloudUploadIcon, { class: "h-7 w-7 text-gray-500" }),
                    _createTextVNode(),
                    _createElementVNode("label", {
                        for: `${_ctx.name}-file-upload`,
                        class: "cursor-pointer text-gray-500 ml-2"
                    }, "Drop your files here", 8, _hoisted_2)
                ]),
                _createTextVNode(),
                _createElementVNode("input", {
                    id: `${_ctx.name}-file-upload`,
                    multiple: "",
                    type: "file",
                    name: `${_ctx.name}-file-upload`,
                    class: "invisible absolute top-0 left-0 w-full h-full",
                    accept: _ctx.allowedFileTypes.join(', '),
                    disabled: _ctx.disabled,
                    onChange: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                }, null, 40, _hoisted_3)
            ], 34))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "\n      * Allowed file extensions: " + _toDisplayString(_ctx.allowedExtensionsHint), 1))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (!_ctx.disabled && _ctx.maxFileSizeBytes)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "\n      * Maximum file size: " + _toDisplayString(_ctx.maxFileSizeLabel), 1))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (!_ctx.disabled && _ctx.showMacroWarning)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "\n      * Please Note: Microsoft Excel Macro-Enabled Worksheets cannot be\n      submitted via the SLAM Portal\n    "))
            : _createCommentVNode("", true),
        _createTextVNode(),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
            return (_openBlock(), _createElementBlock("div", {
                key: file.name,
                class: "mt-4 shadow mb-2"
            }, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_DocumentTextIcon, { class: "h-10 w-10 text-gray-500" }),
                        _createTextVNode(),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.displayFileName(file.name)), 1)
                    ]),
                    _createTextVNode(),
                    (!_ctx.disabled && file.uploaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("button", {
                                onClick: _withModifiers(($event) => (_ctx.handleDownload(index)), ["prevent"])
                            }, [
                                _createVNode(_component_DownloadIcon, { class: "text-gray-500 hover:text-gray-800 h-6 w-6" })
                            ], 8, _hoisted_11),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                class: "ml-4",
                                onClick: ($event) => (_ctx.handleDeleteFile(index))
                            }, [
                                _createVNode(_component_XIcon, { class: "w-5 h-5 text-gray-500 hover:text-gray-800" })
                            ], 8, _hoisted_12)
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.disabled && file.uploaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("button", {
                                onClick: _withModifiers(($event) => (_ctx.handleDownload(index)), ["prevent"])
                            }, [
                                _createVNode(_component_DownloadIcon, { class: "text-gray-500 hover:text-gray-800 h-6 w-6" })
                            ], 8, _hoisted_14)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        }), 128))
    ]));
}
